// Constructor
function World(app, shaders) {

	this.p = app;

	this.recording = false;

	this.mix = {opacity: 1};

	this.pan = {
		x: 0,
		y: 0
	}

	this.panLimits = {
		xMin: -0.25,
		xMax: 0.25,
		yMin: -0.25,
		yMax: 0.25
	}

	this.scale = 1;

	this.container = document.getElementById('container');
	this.overlay = document.getElementById('overlay');
	this.wrapper = document.getElementById('wrapper');

	this.camera = new THREE.Camera();
	this.camera.position.z = 1;

	this.scene = new THREE.Scene();
	var geometry = new THREE.PlaneBufferGeometry(2, 2);

	this.videoTexture = new THREE.Texture(this.p.camera.videoCanvas);
	this.videoTexture.minFilter = THREE.LinearFilter;
	this.videoTexture.magFilter = THREE.LinearFilter;

	// this.noiseTextures = [
	// 	new THREE.TextureLoader().load("assets/textures/noise1.png"),
	// 	new THREE.TextureLoader().load("assets/textures/noise2.png"),
	// 	new THREE.TextureLoader().load("assets/textures/noise3.png"),
	// 	new THREE.TextureLoader().load("assets/textures/noise4.png"),
	// 	new THREE.TextureLoader().load("assets/textures/noise5.png"),
	// 	new THREE.TextureLoader().load("assets/textures/noise6.png")
	// ];

	this.uniforms = {
		time: {type: "f", value: 1.0},
		resolution: {type: "v2", value: new THREE.Vector2()},
		scale: {type: "v2", value: new THREE.Vector2()},
		texture1: {type: "t", value: null},
		// texture2: {type: "t", value: this.noiseTextures[this.defaultNoise]},
		transit: {type: "f", value: 1.0},
		effect: {type: "f", value: 0.0},
		mode: {type: "f", value: 0.0},
		panOffset: {type: "f", value: 0.15},
		pan: {type: "v2", value: new THREE.Vector2()}
	};

	this.uniforms["scale"].value.x = this.scale;

	var material = new THREE.ShaderMaterial({
		uniforms: this.uniforms,
		vertexShader: shaders["vertex"],
		fragmentShader: shaders["fragment"],
		// vertexShader: document.getElementById('vertexShader').textContent,
		// fragmentShader: document.getElementById('fragmentShader').textContent
	});

	var mesh = new THREE.Mesh(geometry, material);
	this.scene.add(mesh);

	this.renderer = new THREE.WebGLRenderer();
	this.renderer.setPixelRatio(1);
	this.container.appendChild(this.renderer.domElement);
	jQuery(this.renderer.domElement).attr("id", "render");

	// create a second canvas of smaller size for video capture
	this.capture = new THREE.WebGLRenderer();
	this.capture.setPixelRatio(1);
	this.container.appendChild(this.capture.domElement);
	jQuery(this.capture.domElement).attr("id", "capture");
	this.capture.setSize(320, 360, true);

	this.resize();
	// this.renderer.setSize(960, 1080, true);
	// this.uniforms["resolution"].value.x = this.renderer.domElement.width * this.scale;
	// this.uniforms["resolution"].value.y = this.renderer.domElement.height * this.scale;

	jQuery(window).on("resize", jQuery.proxy(this.resize, this));
}

// Flip pov
World.prototype.update = function (mode) {
}

World.prototype.update = function () {
	this.uniforms["time"].value += 0.05;
	this.uniforms["texture1"].value = this.videoTexture;
	this.uniforms["transit"].value = this.mix.opacity;
	this.uniforms["scale"].value.x = this.scale;

	this.uniforms["pan"].value.x = 0;
	this.uniforms["pan"].value.y = 0;

	if (this.p.camera.hasStream()) {
		this.renderer.render(this.scene, this.camera);
		this.capture.render(this.scene, this.camera);
	}
}

World.prototype.resize = function () {
	var containerWidth = jQuery(this.container).width();
	var containerHeight = jQuery(this.container).height();

	console.log(containerWidth, containerHeight)

	// var ratio = containerWidth / containerHeight;

	// if (ratio >= 8 / 9) {
	// 	this.renderer.setSize((8 / 9 * containerHeight), containerHeight, true);
	// 	// this.renderer.setViewport( 0, 0, (8 / 9 * jQuery(this.container).height()), jQuery(this.container).height() );
	// } else {
		this.renderer.setSize(containerWidth, (9 / 8 * containerWidth), true);
		// this.renderer.setViewport( 0, 0, jQuery(this.wrapper).width(), (9 / 8 * jQuery(this.wrapper).width()));
	// }

	this.uniforms["resolution"].value.x = this.renderer.domElement.width * this.scale;
	this.uniforms["resolution"].value.y = this.renderer.domElement.height * this.scale;
}


// Expose App
window.World = World;